// extracted by mini-css-extract-plugin
export default {"profileContainer":"prudna-history_profileContainer__tOQsP","content":"prudna-history_content__yBAkn","tips":"prudna-history_tips__pw7nl"};